import React, { useState, Fragment } from 'react'
import { Dialog, Transition } from "@headlessui/react";
import troubleImage from '../../images/trouble.png';


function BookingId() {

    let [isOpen, setIsOpen] = useState(false);

    function closeModal() {
        setIsOpen(false);
      }
    
      function openModal() {
        setIsOpen(true);
      }

    return (
        <div className='section-wrap'>
        <div className="text-center mt-20 mx-4">
            <div className="guestName sm:text-center text-left">Hi Guest name</div>
            <div className="bookP sm:text-center text-left pt-3">Please enter your <span className='bookSpan'>Booking id</span> to enjoy the services provided by the hotel</div>
            <form>
                <div className="mt-6 relative">
                    <input className="input" type="text" placeholder='Your Hotel Booking ID' />
                    {/* {validationMsg && (
            <span className="absolute animate-bounce text-sm text-red-500 left-[46%] -translate-x-1/2 -bottom-6">
              Invalid Number
            </span>
          )} */}
                </div>
                {/* <button
          className={
            !phoneError == "" ? "inactive-button mt-7 flex items-center justify-center mx-auto" : "active-button mt-7 flex justify-center items-center mx-auto"
          }
        >
          Continue and get OTP

          {loading ? <div className="loader ml-4"></div> : null}
        </button> */}
                <button
                    className="active-button mt-7 flex justify-center items-center mx-auto">
                    Enter
                    {/* {loading ? <div className="loader ml-4"></div> : null} */}
                </button>
            </form>
            <div onClick={openModal} className='trouble mt-6 w-fit p-[10px] mx-auto cursor-pointer'>Have trouble finding your <span className='text-[#FDDB62] pl-1 font-bold'>booking id?</span></div>
        </div>
        <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-[80] overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-20 backdrop-filter backdrop-blur" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-4 my-8 overflow-hidden text-left align-middle transition-all transform bg-[#2E2842] shadow-xl rounded-2xl">
                {/*header*/}
                <div className="flex items-start justify-between px-5 py-0 rounded-t">
                  <h3 className="text-3xl font-semibold">

                  </h3>
                </div>
                {/*body*/}
                <div className='modalBar mt-1 mx-auto'></div>
                <div className='mt-8 text-xl font-medium text-left sm:text-center'>Trouble finding your <span className='font-semibold'>Booking Id</span></div>
                <div className='mt-4 text-sm font-medium text-[#C8C8C8] text-left sm:text-center'>Please check your email , message or Whatsapp  for the Booking ID</div>
                <div className='mt-7 flex sm:justify-center justify-start'>
                    <img src={troubleImage} />
                </div>
                <div className='mt-7 text-[#C8C8C8] font-medium text-sm'>Or Contact the Reception desk of the hotel</div>
                
                
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
        </div>
    )
}
export default BookingId
